import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import ConnexionBanner from '../shared/ConnexionBanner';

export default function AdminLayout() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F0F2F5' }}>
      <AdminSidebar />
      <main style={{
        flex: 1,
        marginLeft: 'var(--sidebar-width)',
        padding: '1.5rem',
        maxWidth: '100%',
        overflowX: 'hidden',
      }}>
        <ConnexionBanner />
        <Outlet />
      </main>
    </div>
  );
}
